import styled from "styled-components";
import { Dropdown } from "react-bootstrap";
import { } from "../../../constants";

export const DropdownContainer = styled(Dropdown.Menu)`
  position: absolute;
  z-index: 1000;
  min-width: 150px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: white;
`;
